import { motion } from "framer-motion";
import { BadgeCheck, Linkedin } from "lucide-react";
import { BRAND, FOUNDER_STATS } from "@/lib/site";

export const Founder = () => {
  return (
    <section id="founder" data-testid="founder-section" className="relative bg-zi-tint2 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5"
          >
            <div className="relative mx-auto max-w-sm">
              <div className="absolute -inset-3 rounded-[2rem] bg-gradient-to-br from-zi-accent/40 to-zi-primary/25 blur-xl" />
              <div className="relative overflow-hidden rounded-[2rem] border border-zi-line bg-white shadow-xl shadow-zi-primary/10">
                <img
                  src={BRAND.founderPhoto}
                  alt="Afftab Ahmed, Founder & Director"
                  loading="lazy"
                  className="aspect-square w-full object-cover"
                />
                <div className="flex items-center justify-between border-t border-zi-line bg-white p-5">
                  <div>
                    <div className="font-heading text-xl font-bold text-zi-ink">Afftab Ahmed</div>
                    <div className="flex items-center gap-1.5 font-sans text-sm font-semibold text-zi-primary">
                      <BadgeCheck size={15} /> Founder &amp; Director
                    </div>
                  </div>
                  <a
                    data-testid="founder-linkedin-icon"
                    href={BRAND.founderLinkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Afftab Ahmed on LinkedIn"
                    className="flex h-10 w-10 items-center justify-center rounded-xl bg-zi-primary/10 text-zi-primary transition-all duration-300 hover:bg-zi-primary hover:text-white"
                  >
                    <Linkedin size={18} />
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-7"
          >
            <p className="font-heading text-sm font-extrabold uppercase tracking-[0.22em] text-zi-primary">
              Meet the Founder
            </p>
            <h2 className="mt-4 font-heading text-4xl font-bold tracking-tight text-zi-ink sm:text-5xl">
              Turning admin burdens into your edge.
            </h2>
            <p className="mt-6 max-w-2xl font-sans text-lg leading-relaxed text-zi-muted">
              "With over 13 years of hands-on expertise, I've helped businesses of
              every size slash operational costs and unlock new levels of
              efficiency and productivity. At Zippy Infosolution, we turn
              administrative burdens into your competitive edge — with a team you
              can genuinely rely on."
            </p>
            <p className="mt-4 font-heading text-lg font-semibold text-zi-ink">— Afftab Ahmed, Founder &amp; Director</p>

            <a
              data-testid="founder-linkedin-button"
              href={BRAND.founderLinkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-zi-primary px-6 py-3 font-heading text-sm font-semibold text-white shadow-lg shadow-zi-primary/25 transition-all duration-300 hover:bg-zi-accent"
            >
              <Linkedin size={17} /> Connect on LinkedIn
            </a>

            <div className="mt-9 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {FOUNDER_STATS.map(([big, small]) => (
                <div key={small} className="rounded-2xl border border-zi-line bg-white p-4 shadow-sm">
                  <div className="font-heading text-2xl font-bold text-zi-primary">{big}</div>
                  <div className="font-sans text-xs text-zi-muted">{small}</div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Founder;
